import merge from 'deepmerge';
import { combineReducers } from 'redux';

const specDocs = () => (
  state = {
    // inital states here
    specDocsData: null,
  },
  action,
) => {
  if (action.type === 'SPECDOCS_SUCCESS' && action.response.entities) {
    return merge.all([state, action.response.entities], {
      clone: false,
      arrayMerge: (destinationArray, sourceArray) => sourceArray,
    });
  }
  return state;
};

export default combineReducers({
  specDocs: specDocs(),
});
